var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "12", height: "10", viewBox: "0 0 12 10" }, props),
    React.createElement("path", { fillRule: "evenodd", d: "M3.698 7.717l5.96-6.235a.75.75 0 1 1 1.084 1.036l-6.5 6.8a.75.75 0 0 1-1.082.003l-2.7-2.8a.75.75 0 0 1 1.08-1.042l2.158 2.238z" })
  );
});